import { KpopStudyPageTemplate } from "@/components/KpopStudyPageTemplate";

const StudyWithEXO = () => {
  return (
    <KpopStudyPageTemplate
      groupName="EXO"
      groupNameDisplay="EXO"
      fandomName="EXO-Ls"
      seoTitle="Study With EXO - EXO Study Rooms"
      seoDescription="Study with EXO fans worldwide. Join EXO-Ls in virtual study rooms with EXO playlists and productivity tools."
      seoKeywords="study with exo, exo study room, exo-l study, kpop study room"
      canonicalUrl="/study-with-exo/"
      heroDescription="Join a global community of EXO-Ls who combine their passion for EXO with productive study sessions."
      aboutContent={
        <>
          <p>
            <a href="https://exo.smtown.com/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">EXO</a> is a South Korean-Chinese boy band formed by <a href="https://www.smentertainment.com/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">SM Entertainment</a> in 2012. Known for their powerful performances and vocals.
          </p>
          <p>
            EXO's fanbase, known as EXO-L (EXO Love), has been a driving force in K-Pop history. Follow them on <a href="https://www.instagram.com/weareone.exo/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Instagram</a>, <a href="https://twitter.com/weareoneEXO" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">X (Twitter)</a>, and <a href="https://www.youtube.com/@EXO" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">YouTube</a>.
          </p>
        </>
      }
      riseOfContent={
        <p>
          EXO fans have created spaces to combine their passion with productive study sessions, playing <a href="https://open.spotify.com/artist/3cjEqqelV9zb4BYE3qDQ4O" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">EXO's music on Spotify</a> in the background.
        </p>
      }
      featureCards={[
        { title: "EXO Study Playlists", desc: "Curated playlists featuring EXO's legendary discography to keep you motivated." },
        { title: "Connect with EXO-L", desc: "Meet fellow EXO-Ls from around the world who share your passion." },
        { title: "Power-Themed Rooms", desc: "Study rooms with EXO-inspired aesthetics and cosmic vibes." },
        { title: "We Are One Sessions", desc: "Study together as one with EXO-Ls worldwide." },
      ]}
      whyPerfectDescription="CSW is more than just a study platform; it's a place where fans of EXO can come together, stay motivated, and achieve their goals. We are one!"
      communityDescription1="CSW – Chill Study Work is more than just a study platform; it's a place to connect with like-minded individuals."
      communityDescription2="Discover how studying with your favorite idols can transform your academic journey."
      socialLinks={[
        { name: "Official Website", url: "https://exo.smtown.com/" },
        { name: "YouTube", url: "https://www.youtube.com/@EXO" },
        { name: "Instagram", url: "https://www.instagram.com/weareone.exo/" },
        { name: "X (Twitter)", url: "https://twitter.com/weareoneEXO" },
        { name: "Spotify", url: "https://open.spotify.com/artist/3cjEqqelV9zb4BYE3qDQ4O" },
      ]}
      youtubeVideos={[
        { id: "pSudEWuqLbE", title: "EXO - Love Shot M/V" },
        { id: "KSH-FVVtTf0", title: "EXO - Monster M/V" },
        { id: "iwd8N6K-sLk", title: "EXO - Tempo M/V" },
        { id: "yWfsla_Uh80", title: "EXO - Ko Ko Bop M/V" },
        { id: "pQ_6LJXq8qU", title: "EXO - Obsession M/V" },
        { id: "TI0DGvqKZTI", title: "EXO - Call Me Baby M/V" },
      ]}
      youtubeChannelUrl="https://www.youtube.com/@EXO"
      youtubeChannelName="EXO"
    />
  );
};

export default StudyWithEXO;
